module.exports = __webpack_public_path__ + "static/media/green.f1e9ec23.png";